import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { history } from './redux/store/history';
import { NotFound, LaDMonitor } from './common/containers/pages'
import {
    Top, Login, Remind, ResetPassword, SettingPassword, Training,
    Home, CognitionGrammar, VideoCognitionGrammar, WebinarArchive, VideoWebinarArchive,
    Content, Notice, Faq, Account,
    LoginAdmin, TopAdmin, UserCtrl, UserEdit, NoticeCtrl, NoticeEdit, RecordCtrl,
    TopTrainer, CommentEdit, SubjectManage, Tutorial
} from './app/containers/pages'
import { PrivateRoute } from './PrivateRoot';

import { USERTYPE } from './app/common/constants.js';
import { ErrorDialog, MaintenanceDialog } from './app/components/molecues';

class Root extends Component {
    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route exact path='/' component={Login} />
                    <Route exact path='/login' component={Login} />
                    <Route exact path='/remind' component={Remind} />
                    <Route exact path='/resetpassword' component={ResetPassword} />
                    <PrivateRoute exact path='/home' component={Home} />
                    <PrivateRoute exact path='/cognitiongrammar' component={CognitionGrammar} />
                    <PrivateRoute exact path='/videocognitiongrammar' component={VideoCognitionGrammar} />
                    <PrivateRoute exact path='/webinararchive' component={WebinarArchive} />
                    <PrivateRoute exact path='/videowebinararchive' component={VideoWebinarArchive} />
                    <PrivateRoute exact path='/content' component={Content} />
                    <PrivateRoute exact path='/notice' component={Notice} />
                    <PrivateRoute exact path='/faq' component={Faq} />
                    <PrivateRoute exact path='/account' component={Account} />
                    <PrivateRoute exact path='/top' component={Top} />
                    <PrivateRoute exact path='/training' component={Training} />
                    <PrivateRoute exact path='/settingpassword' component={SettingPassword} />
                    <PrivateRoute exact path='/tutorial' component={Tutorial} />
                    <Route exact path='/admin' component={LoginAdmin} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/top' component={TopAdmin} />
                    <PrivateRoute permission={[USERTYPE.ADMIN, USERTYPE.TRAINER]} exact path='/admin/user' component={UserCtrl} />
                    <PrivateRoute permission={[USERTYPE.ADMIN, USERTYPE.TRAINER]} exact path='/admin/user-edit' component={UserEdit} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/notice' component={NoticeCtrl} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/notice-edit' component={NoticeEdit} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/record' component={RecordCtrl} />
                    <PrivateRoute permission={[USERTYPE.TRAINER]} exact path='/admin/trainer/top' component={TopTrainer} />
                    <PrivateRoute permission={[USERTYPE.TRAINER]} exact path='/admin/trainer/comment-edit' component={CommentEdit} />
                    <PrivateRoute permission={[USERTYPE.TRAINER]} exact path='/admin/trainer/subject' component={SubjectManage} />
                    <PrivateRoute exact path='/ladmonitor' component={LaDMonitor} />
                    <Route component={NotFound} />
                </Switch>
                <ErrorDialog />
                <MaintenanceDialog />
            </Router>
        );
    }
}

export { Root };